import React from 'react';

export default function UserCommunicationGeneralPage() {
    return <div>UserCommunicationGeneralPage</div>;
}
